<!--page starts-->
<section class="page-wrapper">
    <div class="news-hero-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
           <div class="news-hero-detail">
           	    <div class="t-twenty-titel">
                    <h2>{{bannerList?.title}}</h2>
                </div>
           </div>
        </div>
    </div>
    <div class="t-twenty-score-section">
        <div class="second-fixtures-detail-tab-detail fixtures-main-content ">
            <div class="leicester-match-section t-twenty-score cf">
                <div class="container">
                    <div class="leicester-match-box" *ngIf="livematchesList.data.length == 0">
                        <div class="leicester-match-box-first">
                            <h3>{{matchesList?.data[0]?.date_time | amDateFormat: "ddd"}}</h3>
                            <h2>{{matchesList?.data[0]?.date_time | amDateFormat: "DD MMM"}}</h2>
                            <h3>{{matchesList?.data[0]?.date_time | amDateFormat: "hh:mm A"}}</h3>
                            <p>{{matchesList?.data[0]?.series_catagory_title}}</p>
                        </div>
                        <div class="leicester-match-box-left">
                            <div class="leicester-match-box-left-logo-box">
                                <div class="leicester-match-left">
                                    <div class="leicester-match-left-image">  
                                        <img [src]="matchesList?.data[0]?.first_image">
                                    </div>
                                    <div class="leicester-match-left-team">
                                        <h3>{{matchesList?.data[0]?.first_name}}</h3>
                                    </div>
                                </div>
                                <div class="leicester-match-right">
                                    <div class="leicester-match-left-image">  
                                        <img [src]="matchesList?.data[0]?.second_image">
                                    </div>
                                    <div class="leicester-match-left-team">
                                        <h3>{{matchesList?.data[0]?.second_name}}</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="leicester-match-box-left-content">
                                <p>{{matchesList?.data[0]?.location}}</p>
                            </div>
                        </div>
                        
                        <div class="leicester-match-box-right">
                            <h3>THE COUNTDOWN IS ON!</h3>
                            <div class="counter">
                                <!--<countdown class="week-two-timer"></countdown>-->
                                <!-- <div class="counter-box">
                                    <p><span class="number">5</span><span class="content">Days</span></p>
                                </div>
                                <div class="counter-box">
                                    <p><span class="number">22</span><span class="content">Hours</span></p>
                                </div>
                                <div class="counter-box">
                                    <p><span class="number">31</span><span class="content">Minutes</span></p>
                                </div>
                                <div class="counter-box">
                                    <p><span class="number">31</span><span class="content">Seconds</span></p>
                                </div> -->
                            </div>
                            <a href="{{matchesList?.data[0]?.redirect_url}}" *ngIf="matchesList?.data[0]?.redirect_url && matchesList?.data[0]?.is_sold_out == 'No'" target="_blank">Book Tickets</a>
                            <a *ngIf="matchesList?.data[0]?.is_sold_out == 'Yes'" disabled class="grey">SOLD OUT</a>
                        </div>
                        <div class="leicester-match-overlay"></div>
                    </div>
                    <div class="leicester-match-box" *ngIf="livematchesList.data.length > 0">
                        <div class="leicester-match-box-first">
                            <h3>{{livematchesList?.data[0]?.date_time | amDateFormat: "ddd"}}</h3>
                            <h2>{{livematchesList?.data[0]?.date_time | amDateFormat: "DD MMM"}}</h2>
                            <h3>{{livematchesList?.data[0]?.date_time | amDateFormat: "hh:mm A"}}</h3>
                            <p>{{livematchesList?.data[0]?.series_catagory_title}}</p>
                        </div>
                        <div class="leicester-match-box-left">
                            <div class="leicester-match-box-left-logo-box">
                                <div class="leicester-match-left">
                                    <div class="leicester-match-left-image">  
                                        <img [src]="livematchesList?.data[0]?.first_image">
                                    </div>
                                    <div class="leicester-match-left-team">
                                        <h3>{{livematchesList?.data[0]?.first_name}}</h3>
                                    </div>
                                </div>
                                <div class="leicester-match-right">
                                    <div class="leicester-match-left-image">  
                                        <img [src]="livematchesList?.data[0]?.second_image">
                                    </div>
                                    <div class="leicester-match-left-team">
                                        <h3>{{livematchesList?.data[0]?.second_name}}</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="leicester-match-box-left-content">
                                <p>{{livematchesList?.data[0]?.location}}</p>
                            </div>
                        </div>
                        
                        <div class="leicester-match-box-right">
                            <a href="https://www.leicestershireccc.co.uk/livescore/{{livematchesList?.data[0]?.matchid}}" class="livecta" *ngIf="livematchesList?.data[0]?.matchid != ''">Watch Now</a>
                        </div>
                        <div class="leicester-match-overlay"></div>
                    </div>    
                </div>
            </div>
         </div>
    </div>
    <div class="t-twenty-upcomeing-section">
        <div class="container">
            <div class="leicester-detail-bottom cf">
                <div class="leicester-detail-bottom-inner">
                    <div class="titel">
                        <h2 class="titel-name">Upcoming Matches </h2>
                    </div>
                    <div class="leicester-match-section match-main-content ">
                        <div class="leicester-match-section-inner">
                            <ngx-slick-carousel class="carousel" slickModal="slick-carousel"
                                [config]="slidematchConfig">
                                <div ngxSlickItem class="leicester-match-boxold slide"  *ngFor="let upcoming of matchesList?.data">
                                <div  class="leicester-match-box "  [ngStyle]="{'background-image':'url(' + upcoming?.image + ')'}">
                                    <div class="leicester-match-box-left">
                                        <div class="leicester-match-box-left-logo-box">
                                            <div class="leicester-match-left">
                                                <img [src]="upcoming?.first_image">
                                            </div>
                                            <div class="leicester-match-center">
                                                <h2>vs</h2>
                                            </div>
                                            <div class="leicester-match-right">
                                                <img [src]="upcoming?.second_image">
                                            </div>
                                        </div>
                                        <div class="leicester-match-box-left-content">
                                            <h4>{{upcoming?.location}}</h4>
                                            <p>{{upcoming?.date_time | amDateFormat: "DD MMM YYYY,"}} Starts {{upcoming?.date_time | amDateFormat: "HH:mm"}}</p>
                                        </div>
                                    </div>
                                    <div class="leicester-match-box-right">
                                        <div class="leicester-match-box-right-btn">
                                            <a href="{{upcoming?.redirect_url}}" *ngIf="upcoming?.redirect_url && upcoming?.is_sold_out == 'No'" target="_blank">Book Tickets</a>
                                            <a  *ngIf="upcoming?.is_sold_out == 'Yes'" disabled class="grey">SOLD OUT</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </ngx-slick-carousel>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    <a class="club-fischer-current-event-section" href="{{banneraddList?.url}}" target="_blank" [ngStyle]="{'background-image':'url(' + banneraddList?.file + ')'}" >
        <div class="container">
            <!-- <div class="club-fischer-current-event-detail">
                <a href="#">View Hospitality</a>
            </div> -->
        </div>
    </a>
    <div class="news-bottom-section cf">
        <div class="container">
            <div class="news-bottom-detail cf" >
                <div class="titel-box">
                        <h2 class="titel-name">Foxes TV</h2>
                    </div>
                    <div class="video-bottom-section">
                     <div class="latest-new-detail cf">
                            <div class="latest-video-box" *ngFor="let video of videoList?.data| slice:0:3; let i = index ">
                                <div class="latest-video-box-top">
                                    <a href="{{video?.video}}" class="popup-youtube">
                                        <div class="latest-new-image">
                                            <img [src]="video?.thumbnail_image">
                                        </div>
                                        <div class="latest-new-image-hover">
                                            <img [src]="video?.image">
                                        </div>
                                        <div class="video-overlay">
                                          <div class="video-paly-icon"><a href="{{video?.video}}" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
                                          <div class="video-overlay-content"><div class="video-overlay-text"><p>{{video?.title}}</p></div></div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
            </div> 
        </div>
    </div>
    <div class="club-fischer-bottom-section">
        <div class="container">
            <div class="club-fischer-bottom-detail" >
                <div class="titel-box">
                    <h2 class="titel-name">Your Running Foxes </h2>
                </div>
                <div class="club-facilities-detail">
                    <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideconcertsConfig">
                        <div ngxSlickItem class="club-facilities-box slide" *ngFor="let running of runnigList?.data; let i = index ">
                            <a class="club-facilities-box-iamge" href="{{running?.url}}">
                                <img [src]="running?.image">
                            </a>
                        </div>
                      
                        
                    </ngx-slick-carousel>
                </div>
            </div>
            <div class="club-fischer-bottom-detail" >
                <div class="titel-box">
                    <h2 class="titel-name">Look the Part</h2>
                </div>
                <div class="club-facilities-detail" >
                    <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidePefectConfig">
                        <div ngxSlickItem class="club-facilities-box slide" *ngFor="let part of partList?.data; let i = index ">
                            <a class="club-facilities-box-iamge" href="{{part?.url}}">
                                <img [src]="part?.image">
                            </a>
                        </div>
                      
                    </ngx-slick-carousel>
                </div>
            </div>
            <div class="t-twenty-join-the-section">
                <div class="container">
                    <div class="t-twenty-join-the-detail">
                        <div class="titel-box">
                            <h2 class="titel-name">Join the Conversation </h2>
                        </div>
                        <div class="t-twenty-join-the">
                            <div class="t-twenty-join-the-box" *ngFor="let join of joinList?.data; let i = index ">
                                <h3>{{join?.title}} </h3>
                                <div [innerHTML]="join?.description"></div>
                                <!-- <p>It’s who we are. We are unique. It’s who we represent. We are ambassadors of the Club. We are proud to be Running Foxes. Our colours are Green and Red. We stand shoulder-to-shoulder. We are winners. We remain positive in adversity. We wear the crest with pride. We are one team.</p> -->
                            </div>
                            <!-- <div class="t-twenty-join-the-box">
                                <h3>#HungryForMore. </h3>
                                <p>It’s who we are. We are unique. It’s who we represent. We are ambassadors of the Club. We are proud to be Running Foxes. Our colours are Green and Red. We stand shoulder-to-shoulder. We are winners. We remain positive in adversity. We wear the crest with pride. We are one team.</p>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->